var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFinger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.48,
    height: 18.51,
    viewBox: "0 0 18.48 18.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-fingerprint"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,11a8.23,8.23,0,1,1,7.5,8.9A8.27,8.27,0,0,1,4.3,11Zm1.2.1a7,7,0,1,0,7.6-6.4A7.18,7.18,0,0,0,5.5,11.1Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,21.2l-1.5-1.7a.57.57,0,1,1,.9-.7l1.5,1.7a.52.52,0,0,1-.1.8c-.1.1-.3.2-.4.1S19.9,21.4,19.8,21.2Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.6,12.4v.5c0,.3.2.5.5.4a.47.47,0,0,0,.5-.5,6.8,6.8,0,0,1,.2-2,4.43,4.43,0,0,1,2-2.7,3.18,3.18,0,0,1,2.7-.4,3,3,0,0,1,1,.4,1.82,1.82,0,0,1,1.1,2c-.1.6-.3,1.3-.4,1.9a3.66,3.66,0,0,0,0,1.8,1.38,1.38,0,0,0,.3.4c.1.2.4.2.6.2s.4-.3.3-.5a2.44,2.44,0,0,1-.1-2.2c.1-.6.3-1.2.4-1.8.1-1.2-.6-2.1-2-2.7a7.12,7.12,0,0,0-2.1-.4,4.47,4.47,0,0,0-2.8.9,6.13,6.13,0,0,0-2.1,3A13.05,13.05,0,0,0,7.6,12.4Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,14",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,14.5v.6c0,.4.2.6.5.6s.5-.2.5-.6a6.6,6.6,0,0,1,.1-1.4,6.2,6.2,0,0,1,.9-3,1.17,1.17,0,0,1,.6-.6,1.06,1.06,0,0,1,1.6.4,2.44,2.44,0,0,1,0,1.2l-.3,2.1a5.5,5.5,0,0,0,.2,2.2.55.55,0,0,0,.8.3.37.37,0,0,0,.2-.5,5.33,5.33,0,0,1-.1-2.8,7.84,7.84,0,0,0,.2-2.2A2.07,2.07,0,0,0,12.3,9a2.46,2.46,0,0,0-1.7,1,5.15,5.15,0,0,0-.9,2A10.07,10.07,0,0,0,9.4,14.5Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,14.8c.1.4.1.9.2,1.5.1.3.3.5.6.4a.44.44,0,0,0,.4-.6c-.1-.5-.1-1-.2-1.6a5.38,5.38,0,0,1,.4-2.2c0-.1.1-.2,0-.3a.46.46,0,0,0-.5-.4c-.2,0-.5.1-.5.3-.1.5-.3,1.1-.4,1.6Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_129",
    "data-name": "Capa 129"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.3,6.2c.1-.2-.2-.7-.4-1s-.3-.4-.6-.7a4.81,4.81,0,0,0-1.2-1H18c-.1,0-.2-.1-.3-.1a.22.22,0,0,0-.2.2c-.1.3,1,.8,1.8,2,.2.3.5.8.8.8C20.2,6.3,20.3,6.3,20.3,6.2Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 7.51,
    rx: 0.3,
    ry: 0.4,
    transform: "translate(-4.51 4.94) rotate(-20.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_130",
    "data-name": "Capa 130"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.9,
    cy: 15.9,
    rx: 0.3,
    ry: 0.4,
    transform: "translate(-8.93 -0.37) rotate(-22.22)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6,17.1c-.1.2.2.7.4,1s.3.4.6.7a8.4,8.4,0,0,0,1.2,1h.1c.1,0,.2.1.3.1s.2-.2.2-.2c.1-.3-1-.7-1.8-1.9-.2-.4-.5-.8-.8-.8C4.7,17,4.6,17,4.6,17.1Z",
    transform: "translate(-3.21 -3.03)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFinger);
export default __webpack_public_path__ + "static/media/search-finger.55341c3ee1edbbf735ab6fee4eb3f5d7.svg";
export { ForwardRef as ReactComponent };